import { Link } from "react-router-dom";
import { PermissionsProvider } from "../../../../contexts/PermissionsContext"
import { NavBar } from "../../../../components/NavBar/NavBar";
import Input from "../../../../components/Inputs/Input";
import './PackageIntake.scss';
import { Sorting } from "../../../../components/Lists/Sorting";
import { DropdownsContext, DropdownsProvider } from "../../../../contexts/DropdownsContext";
import { Boxes } from "./Boxes";
import { AwbDetail } from "./AwbDetail";
import { MobileModal } from "../../../../components/MobileModal/MobileModal";
import { useContext, useEffect, useState } from "react";
import { Camera } from "../../../../components/Camera/Camera";
import { useDispatch, useSelector } from "react-redux";
import { addAwbBatch, addAwbNumber, batchLoadingChange, fetchAwbInfo, fetchBoxes, fetchOrders, intakeAWB, loadingChange, reloadImages, removeAwb, resetPackageIntake, selectAWB, selectAwbInfo, selectAWBN, selectLoading, selectOrders, selectVwNumber } from "../../../../redux/features/StoresModule/packageIntakeSlice";
import { useSnackBar } from "../../../../hooks/useSnackBar";
import { HTTP_RESPONSE_CODES } from "../../../../globals/globals";


const mockOrders = [
    {
        orderNumber: "125-569-998",
        orderType: "PO",
        PN: "125-569-998",
        description: "--",
        QTY: "12 unit"
    }
];

const mockAwbs = [
    { number: "1965-3641-00" },
    { number: "8965-3581-00" },
    { number: "6852-1221-00" }
];

let mockBoxes = [{
    id: 0,
    condition: "crushed",
    photos: []
}]

export const PackageIntake = () => {
    const { dataFromInventoryManagement } = location.state || {};
    const [awbInput, setAwbInput] = useState("");
    const [modOpen, setModOpen] = useState(false);
    const [camOpen, setCamOpen] = useState(false);
    const awbNumbers = useSelector(selectAWBN);
    const currAWB = useSelector(selectVwNumber);
    const orders = useSelector(selectOrders);
    const dispatch = useDispatch();
    const { infoMsg, warningMsg, successMsg } = useSnackBar();
    const loading = useSelector(selectLoading);
    const awbInfo = useSelector(selectAwbInfo);

    const sent = (awb) => loading[awb] ||( awbInfo[awb]?.awbStatus === "sent" || awbInfo[awb]?.awbStatus === "Shipped");
    const intake = (awb) => !loading[awb] && awbInfo[awb]?.awbStatus === "package_in_take";
    const openCamera = () => setCamOpen(true);
    const removeAwbNumber = (e, awb) => {
        e.stopPropagation();
        dispatch(removeAwb({ awb }));
    }

    const onScannerChange = (newList) => {
        dispatch(batchLoadingChange({ awbs: newList, loading: true }));
        dispatch(addAwbBatch(newList));
        dispatch(fetchAwbInfo({ awbList: newList })).then(action => {
            dispatch(batchLoadingChange({ awbs: newList, loading: false }));
        });

        // console.warn("awb list", newList);
        // for (let awb of newList) {
        //     dispatch(loadingChange({awb, loading: true}));
        // }
        // for (let awb of newList){
        //     dispatch(addAwbNumber(awb));
        //     dispatch(fetchOrders({ awb })).then(action => {
        //         dispatch(loadingChange({ awb, loading: false }));
        //     });

        // }
        // setAwbNumbers(prev => [...prev, ...newList]);
    }

    const addManualAwb = () => {
        if (Boolean(awbInput)) {
            dispatch(loadingChange({ awb: awbInput, loading: true }));
            dispatch(addAwbNumber(awbInput));
            dispatch(fetchAwbInfo({ awbList: [awbInput] })).then(action => {
                dispatch(loadingChange({ awb: awbInput, loading: false }))
            });
        }
        setAwbInput("");
    }

    const selectAWBNumber = (awb) => {
        // TODO: info snackbar for orders loading;
        dispatch(selectAWB(awb));
        dispatch(fetchOrders({ awb })).then(action => {
            // TODO: info snackbar when orders are empty;
            let { load } = action.payload;
            if (!(load.length > 0)) {
                infoMsg("No orders found", `No orders found for AWB Number: ${awb}`);
            }
        });
        dispatch(fetchBoxes({ awb, awbId: awbInfo[awb].id })).then(action => {
            console.warn('*boxes action', action);
            if (action.payload?.boxesList) {
                action.payload.boxesList.forEach((box, idx) => {
                    dispatch(reloadImages({ awb, boxIdx: idx, images: box.images }));
                })
            }
        })
    };

    const intakeCall = (e, awb) => {
        e.stopPropagation();
        dispatch(intakeAWB({ awb })).then(action => {
            let { respData } = action.payload;
            if (respData.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
                successMsg("Package Intake Success", `AWB: ${awb}`);
            }
        })
    }

    useEffect(() => {
        // infoMsg("Hola Mundo", "Hola Mundo", 1234132123123);
        dispatch(resetPackageIntake());
    }, [])

    return (
        <>
            {/* TODO: permissions provider */}
            <DropdownsProvider>
                <DropdownsContainer>
                    <PermissionsProvider resourceId={4}>
                        <div className="parts-configuration-component package-intake-component" >
                            <div className="nav-header">
                                <NavBar
                                    dataBreadCrumbs={"/store/package-intake"}
                                    appIcon={"icon-package-intake"}
                                    moduleIcon={"icon-stores"}
                                    moduleColor="#4F79C2"
                                    title={"Package Intake"}
                                    menuTitle={"Stores"}
                                    currentPath={"/store/package-intake"}
                                    previousPath={"/stores"}
                                    moduleId={3}
                                    goBackData={{
                                        icon: "icon-configuration_module_icon",
                                        color: "#7bb9db",
                                        path: "/configuration",
                                        title: "Configuration",
                                        isPinned: false,
                                        componentKey: "configuration",
                                        id: -1,
                                        isModule: true,
                                        date: crypto.randomUUID()
                                    }}
                                />
                                {/* <button
                            onClick={() => setFiltersOpen((prev) => !prev)}
                            className="filter-toggle"
                        >
                            <h2>Filters</h2>
                            <i className={`icon-arrow-down ${filtersOpen ? "open" : ""}`}></i>
                        </button> */}
                            </div>
                            <div className="parts-configuration-component-content">
                                <div className="content-header">

                                    <div className="parts-header package-intake-header">

                                        <b> Manual Input </b>
                                        <Input value={awbInput} onChange={(e) => setAwbInput(e.target.value)} format={false} label="" />
                                        <button className="filled" onClick={addManualAwb}>
                                            <span className="icon-add-new"></span>
                                            <span>
                                                AWB
                                            </span>

                                        </button>
                                    </div>
                                </div>
                                <div className="package-intake-content">

                                    <div className="awb-list">

                                        {awbNumbers?.length > 0 ? awbNumbers.map((i, j) => <div className={`awb ${i === currAWB ? 'selected' : ""}`} key={`${i}-${j}`} onClick={() => selectAWBNumber(i)}>
                                            <div className="awb-info">
                                                <b>{i}</b>
                                                {intake(i) ? <div className="notfound">
                                                    <span className="icon-confirmation"></span>
                                                    <i>Intake complete</i>
                                                </div> : <>
                                                    {
                                                        !sent(i) && <div className="notfound">
                                                            <span className="icon-coloredwarning"><span className="path1"></span><span className="path2"></span></span>
                                                            <i>No AWB Found</i>
                                                        </div>
                                                    }
                                                </>}


                                                {/* {!exists(i, j) &&
                                                    <div className="notfound">
                                                        <span class="icon-coloredwarning"><span class="path1"></span><span class="path2"></span></span>
                                                        <i>No AWB found</i>
                                                    </div>

                                                } */}
                                            </div>

                                            <div className="awb-actions">
                                                <button className="outlined mid-size viewButton" onClick={() => setModOpen(true)}>
                                                    View
                                                </button>
                                                {!intake(i) && <button className="filled mid-size green" onClick={(e) => intakeCall(e, i)}>
                                                    Intake
                                                </button>}
                                                <button className="transparent icon delete" onClick={(e) => removeAwbNumber(e, i)}>
                                                    <i className="icon-delete-new"></i>
                                                </button>
                                                {/* {exists(i, j) ? <>
                                            
                                            </> : <>
                                                <button className="filled mid-size">
                                                    Create AWB
                                                </button>
                                                <button className="filled mid-size danger" onClick={()=>removeAwbAt(j)}>
                                                    Dismiss
                                                </button>
                                            </>} */}

                                            </div>

                                        </div>) : <div className="placeholder-component"> <i>Start by adding AWB numbers</i></div>}

                                    </div>
                                    <MobileModal open={modOpen} title="Detail AWB No - 1965-3641-00" fullScreen closeBtn onClose={() => setModOpen(false)}>
                                        <div className="awb-detail-mobile">
                                            <AwbDetail awb={currAWB} hideTitle orders={orders[currAWB] ?? []} />
                                            <Boxes awb={currAWB} />
                                        </div>

                                    </MobileModal>
                                    <div className="awb-detail-container">

                                        <AwbDetail awb={currAWB} orders={orders[currAWB] ?? []} />
                                    </div>
                                    {/* <div className="table">
                                    <b>Detail AWB No - 1965-3641-00</b>
                                    <Sorting displayButton={false} onOrderChange={() => { }} properties={{ partNumber: "Order Number", description: "Order Type", categoryName: "PN", subCategoryName: "Description", quantity: "QTY" }} />
                                    {[...mockOrders, ...mockOrders, ...mockOrders, ...mockOrders].map(order => <div className="order">
                                        {Object.entries(order).map(([key, value]) => <span>{value}</span>)}
                                    </div>)}
                                </div> */}

                                    <div className="boxes-container">

                                        <Boxes awb={currAWB} />

                                    </div>

                                </div>
                                {/* <DropdownsProvider
                            noPreloadOpts={[
                                51, 52, 53, 50, 54, 56, 60, 67, 73, 4, 5, 6, 7, 8, 9, 10, 75, 77, 78, 80, 81, 86, 17, 19, 15, 74, 94, 95, 98, 114, 115
                            ]}
                        > */}
                                {/* <PartList /> */}
                                {/* </DropdownsProvider> */}
                                <div className="qr-btn-container" onClick={() => openCamera()}>

                                    <button className="floating-main-button filled">
                                        <i className="icon-qr-code"></i>
                                    </button>
                                </div>
                                <Camera open={camOpen} onScannerChange={onScannerChange} onClose={() => setCamOpen(false)} />
                            </div>
                            <div className="paginator-container"></div>
                        </div>
                    </PermissionsProvider>
                </DropdownsContainer>
            </DropdownsProvider>

        </>
    )
}

const DropdownsContainer = ({ children }) => {
    const dropdownIds = [128];
    const { setDropdownIds } = useContext(DropdownsContext);
    useEffect(() => {
        setDropdownIds(dropdownIds);
    }, []);
    return (<>
        {children}
    </>
    )
}